import React, { useContext, useEffect } from "react";

import { Container, Row, Col, Image } from "react-bootstrap";
// import Header from '../../../components/header/Header'
import HeaderB from "../../../components/headerb/HeaderB";
import LoginB from "../../../components/loginb/LoginB";
import { MainContext } from "../../../contexts/MainContext";
import RingLoaderB from "../../../utils/Loader/RingLoaderB";

export default function Welcome() {
  let {
    setZayechB,
    setZayechC,
    setQuestionIdCon,
    setLotNameCon,
    setTitleIdCon,
  } = useContext(MainContext);
  const mainContext = useContext(MainContext);

  useEffect(() => {
    mainContext.setSecondSelectDisabled(true);
    localStorage.removeItem("mainObj2");
    localStorage.removeItem("mainObject");
    setZayechB([]);
    setZayechC([]);
    setQuestionIdCon("");
    setLotNameCon("");
    setTitleIdCon("");
  }, []);
  return (
    <>
      <Container fluid>
        {/* <RingLoaderB /> */}

        <HeaderB />
      </Container>

      <Container>
        <br />
        <br />
        <br />
        <Row>
          <Col xs={10} md={6}>
            <Image
              center
              className="welcome-image"
              src="./images/tozihat1.jpg"
              alt="توضیحات"
              thumbnail
              style={{ border: "none" }}
            />
          </Col>

          <Col xs={12} md={1}>
            {" "}
          </Col>

          <Col xs={8} md={5}>
            <Col xs={12} md={{ span: 6, offset: 3 }}>
              {" "}
              <LoginB />{" "}
            </Col>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={0}>
            {" "}
          </Col>
        </Row>
        <br />
        <br />
        <br />
      </Container>
    </>
  );
}
